module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ABBREVS"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rABBREVS"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "glossary"
  }, [_c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.66"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AASOR")]), _vm._v(" "), _c('i', [_vm._v("Annual of the American Schools of Oriental Research")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.111"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AB")]), _vm._v(" Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.55"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ADAJ")]), _vm._v(" "), _c('i', [_vm._v("Annual of the Department of Antiquities of Jordan")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.49"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AfO")]), _vm._v(" "), _c('i', [_vm._v("Archiv für Orientforschung")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.65"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AJSL")]), _vm._v(" "), _c('i', [_vm._v("American Journal of Semitic Languages and Literatures")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.29"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AJT")]), _vm._v(" "), _c('i', [_vm._v("American Journal of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.97"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Akk.")]), _vm._v(" Akkadian")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.38"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AnBib")]), _vm._v(" Analecta Biblica")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.118"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ANET")]), _vm._v(" J. B. Pritchard, ed., "), _c('i', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(". 3rd ed. Princeton: Princeton Univ. Press, 1969")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.13"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AOAT")]), _vm._v(" Alter Orient und Altes Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.98"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Arab.")]), _vm._v(" Arabic")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.6"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Aram.")]), _vm._v(" Aramaic")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.94"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Assyr.")]), _vm._v(" Assyrian")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.69"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ASTI")]), _vm._v(" "), _c('i', [_vm._v("Annual of the Swedish Theological Institute")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.54"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ATDA")]), _vm._v(" J. Hoftijzer and G. van der Kooij, eds., "), _c('i', [_vm._v("Aramaic Texts from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Alla")]), _vm._v(". Leiden: Brill, 1976")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.57"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AusBR")]), _vm._v(" "), _c('i', [_vm._v("Australian Biblical Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.89"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AV")]), _vm._v(" Authorized (King James) Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.14"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BA")]), _vm._v(" "), _c('i', [_vm._v("Biblical Archaeologist")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.42"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BASOR")]), _vm._v(" "), _c('i', [_vm._v("Bulletin of the American Schools of Oriental Research")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.100"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BDB")]), _vm._v(" F. Brown, S. R. Driver, and C. A. Briggs, "), _c('i', [_vm._v("Hebrew and English Lexicon of the Old Testament")]), _vm._v(". Repr. Oxford: Clarendon, 1959")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.131"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BHK")]), _vm._v(" R. Kittel, et al., eds. "), _c('i', [_vm._v("Biblia Hebraica")]), _vm._v(". Stuttgart: Württembergische Bibelanstalt, 1937")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.4"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BHS")]), _vm._v(" K. Elliger and W. Rudolph, eds., "), _c('i', [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(". Stuttgart: Deutsche Bibelstiftung, 1967–77")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.74"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Bib")]), _vm._v(" "), _c('i', [_vm._v("Biblica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.71"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BJS")]), _vm._v(" Brown Judaic Studies")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.44"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xiii"
    }
  }), _c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BK")]), _vm._v(" "), _c('i', [_vm._v("Bibel und Kirche")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.37"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BR")]), _vm._v(" "), _c('i', [_vm._v("Biblical Research")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.124"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BT")]), _vm._v(" "), _c('i', [_vm._v("The Bible Translator")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.10"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BTB")]), _vm._v(" "), _c('i', [_vm._v("Biblical Theology Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.27"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BWANT")]), _vm._v(" Beiträge zur Wissenschaft vom Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.76"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BZ")]), _vm._v(" "), _c('i', [_vm._v("Biblische Zeitschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.53"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BZAW")]), _vm._v(" Beihefte zur "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.17"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("CBQ")]), _vm._v(" "), _c('i', [_vm._v("Catholic Biblical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.103"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("DJD")]), _vm._v(" Discoveries in the Judaean Desert")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.121"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("DOTT")]), _vm._v(" D. Winton Thomas, ed., "), _c('i', [_vm._v("Documents from Old Testament Times")]), _vm._v(". Repr. New York: Harper & Row, 1961")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.18"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("EBC")]), _vm._v(" Expositor’s Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.5"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Eng.")]), _vm._v(" English")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.56"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("EvT")]), _vm._v(" "), _c('i', [_vm._v("Evangelische Theologie")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.36"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ExpTim")]), _vm._v(" "), _c('i', [_vm._v("Expository Times")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.122"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("FOTL")]), _vm._v(" Forms of the Old Testament Literature")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.105"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("GKC")]), _vm._v(" "), _c('i', [_vm._v("Genesius’ Hebrew Grammar")]), _vm._v(". Ed. E. Kautzsch. Tr. A. E. Cowley. 2nd ed. Oxford: Clarendon, 1910")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.125"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("GNB")]), _vm._v(" Good News Bible (Today’s English Version)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.108"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HALAT")]), _vm._v(" W. Baumgartner, et al., "), _c('i', [_vm._v("Hebräisches und aramäisches Lexikon zum Alten Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.113"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HDB")]), _vm._v(" "), _c('i', [_vm._v("Hastings’ Dictionary of the Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.3"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Heb.")]), _vm._v(" Hebrew")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.22"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HKAT")]), _vm._v(" Handkommentar zum Alten Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.51"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HSM")]), _vm._v(" Harvard Semitic Monographs")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.47"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HTR")]), _vm._v(" "), _c('i', [_vm._v("Harvard Theological Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.23"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HUCA")]), _vm._v(" "), _c('i', [_vm._v("Hebrew Union College Annual")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.64"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("IB")]), _vm._v(" G. A. Buttrick, et al., eds., "), _c('i', [_vm._v("Interpreter’s Bible")]), _vm._v(". 12 vols. Nashville: Abingdon, 1953–56")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.50"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ICC")]), _vm._v(" International Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.102"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("IDB (Sup)")]), _vm._v(" G. A. Buttrick, et al., eds., "), _c('i', [_vm._v("Interpreter’s Dictionary of the Bible")]), _vm._v(". 4 vols. Nashville: Abingdon, 1962. "), _c('i', [_vm._v("Supplementary Volume")]), _vm._v(". Ed. K. Crim, et al. 1976")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.67"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("IEJ")]), _vm._v(" "), _c('i', [_vm._v("Israel Exploration Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.32"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Int")]), _vm._v(" "), _c('i', [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.101"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ISBE")]), _vm._v(" J. Orr, et al., eds., "), _c('i', [_vm._v("International Standard Bible Encyclopedia")]), _vm._v(". 2nd ed. 5 vols. Grand Rapids: Eerdmans, 1939. Rev. ed. Ed. G. W. Bromiley, et al. 4 vols. 1979–88")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.16"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JAOS")]), _vm._v(" "), _c('i', [_vm._v("Journal of the American Oriental Society")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.112"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JB")]), _vm._v(" Jerusalem Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.12"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xiv"
    }
  }), _c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JBL")]), _vm._v(" "), _c('i', [_vm._v("Journal of Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.72"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JCS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Cuneiform Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.33"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JNES")]), _vm._v(" "), _c('i', [_vm._v("Journal of Near Eastern Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.15"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JPOS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Palestine Oriental Society")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.126"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JPST")]), _vm._v(" The JPS Torah Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.68"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JQR")]), _vm._v(" "), _c('i', [_vm._v("Jewish Quarterly Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.21"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JSOT")]), _vm._v(" "), _c('i', [_vm._v("Journal for the Study of the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.31"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JSOTSup")]), _vm._v(" "), _c('i', [_vm._v("JSOT")]), _vm._v(" Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.28"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JSS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Semitic Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.26"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JTS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Theological Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.109"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("KB")]), _vm._v(" L. Koehler and W. Baumgartner, "), _c('i', [_vm._v("Lexicon in Veteris Testamenti Libros")]), _vm._v(". Leiden: Brill, 1958")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.132"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("LS")]), _vm._v(" "), _c('i', [_vm._v("Louvain Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.116"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("LSJ")]), _vm._v(" Liddell, Scott, Jones, "), _c('i', [_vm._v("Greek-English Lexicon")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.1"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("LXX")]), _vm._v(" Septuagint")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.133"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Mish.")]), _vm._v(" Mishnah")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.128"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Moffatt")]), _vm._v(" James Moffatt, "), _c('i', [_vm._v("The Moffatt Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.8"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ms(s).")]), _vm._v(" manuscript(s)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.7"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("MT")]), _vm._v(" Masoretic Text")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.95"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NASB")]), _vm._v(" New American Standard Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.107"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NBD")]), _vm._v(" J. D. Douglas, et al., eds., "), _c('i', [_vm._v("New Bible Dictionary")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.80"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NCBC")]), _vm._v(" New Century Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.81"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NEB")]), _vm._v(" New English Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.114"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NICOT")]), _vm._v(" New International Commentary on the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.120"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NIDNTT")]), _vm._v(" C. Brown, et al., eds. "), _c('i', [_vm._v("New International Dictionary of New Testament Theology")]), _vm._v(". 3 vols. Grand Rapids: Zondervan, 1975–78")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.87"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NIV")]), _vm._v(" New International Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.92"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NJPS")]), _vm._v(" New Jewish Publication Society Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.96"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NKJV")]), _vm._v(" New King James Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.123"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("OBT")]), _vm._v(" Overtures to Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.43"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("OTL")]), _vm._v(" Old Testament Library")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.40"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("OTS")]), _vm._v(" "), _c('i', [_vm._v("Oudtestamentische Studiën")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.79"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("PEFQS")]), _vm._v(" "), _c('i', [_vm._v("Palestine Exploration Fund Quarterly Statement")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.25"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("PEQ")]), _vm._v(" "), _c('i', [_vm._v("Palestine Exploration Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.90"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Pesh.")]), _vm._v(" Peshitta")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.70"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("PJ")]), _vm._v(" "), _c('i', [_vm._v("Palästina-Jahrbuch")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.134"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Proceedings, 1989")]), _vm._v(" J. Hoftijzer and G. van der Kooij, eds. "), _c('i', [_vm._v("The Balaam Text from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Alla")]), _vm._v(" . . . Leiden: Brill, 1990")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.24"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RB")]), _vm._v(" "), _c('i', [_vm._v("Revue biblique")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.30"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RevQ")]), _vm._v(" "), _c('i', [_vm._v("Revue de Qumran")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.86"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xv"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_vm._v("RSV")]), _vm._v(" Revised Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.88"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("RV")]), _vm._v(" Revised Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.135"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Sam. Pent.")]), _vm._v(" Samaritan Pentateuch")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.83"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SB")]), _vm._v(" Sources bibliques")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.35"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBLDS")]), _vm._v(" Society of Biblical Literature Dissertation Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.130"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBLMS")]), _vm._v(" Society of Biblical Literature Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.58"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBLSP")]), _vm._v(" Society of Biblical Literature Seminar Papers")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.73"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBOT")]), _vm._v(" Sacred Books of the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.84"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBT")]), _vm._v(" Studies in Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.62"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ScrHier")]), _vm._v(" Scripta hierosolymitana")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.136"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("SEÅ")]), _vm._v(" "), _c('i', [_vm._v("Svensk Exegetisk Årsbok")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.60"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Sem")]), _vm._v(" "), _c('i', [_vm._v("Semitica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.61"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SJLA")]), _vm._v(" Studies in Judaism in Late Antiquity")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.19"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("SJT")]), _vm._v(" "), _c('i', [_vm._v("Scottish Journal of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.110"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SNTSMS")]), _vm._v(" Society for New Testament Study Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.41"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SOTSMS")]), _vm._v(" Society for Old Testament Study Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.129"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Syr.")]), _vm._v(" Syriac")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.91"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Targ(s).")]), _vm._v(" Targum(s)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.137"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("T.B.")]), _vm._v(" Babylonian Talmud")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.59"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TBT")]), _vm._v(" "), _c('i', [_vm._v("The Bible Today")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.115"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TDNT")]), _vm._v(" G. Kittel and G. Friedrich, eds., "), _c('i', [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(". Tr. and ed. G. W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–76")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.119"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TDOT")]), _vm._v(" G. Botterweck and H. Ringgren, eds., "), _c('i', [_vm._v("Theological Dictionary of the Old Testament")]), _vm._v(". Tr. D. Green, et al. Vols. 1–6 (to date). Grand Rapids: Eerdmans, 1974–90")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.82"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TGUOS")]), _vm._v(" "), _c('i', [_vm._v("Transactions of the Glasgow University Oriental Society")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.138"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("THAT")]), _vm._v(" E. Jenni and C. Westermann, eds., "), _c('i', [_vm._v("Theologisches Handwörterbuch zum Alten Testament")]), _vm._v(". 2 vols. Munich: Kaiser; Zurich: Theologischer Verlag, 1971–76")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.75"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TLZ")]), _vm._v(" "), _c('i', [_vm._v("Theologische Literaturzeitung")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.85"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TOTC")]), _vm._v(" Tyndale Old Testament Commentaries")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.77"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TPQ")]), _vm._v(" "), _c('i', [_vm._v("Theologisch-praktische Quartalschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.106"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TWOT")]), _vm._v(" R. Harris, et al., eds., "), _c('i', [_vm._v("Theological Wordbook of the Old Testament")]), _vm._v(". 2 vols. Chicago: Moody, 1980")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.39"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TynBul")]), _vm._v(" "), _c('i', [_vm._v("Tyndale Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.63"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("UF")]), _vm._v(" "), _c('i', [_vm._v("Ugarit Forschungen")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.93"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Ugar.")]), _vm._v(" Ugaritic")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.11"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("VT")]), _vm._v(" "), _c('i', [_vm._v("Vetus Testamentum")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.46"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("VTSup")]), _vm._v(" Supplements to "), _c('i', [_vm._v("VT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.2"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xvi"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_vm._v("Vulg.")]), _vm._v(" Vulgate")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.34"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WBC")]), _vm._v(" Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.52"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WEC")]), _vm._v(" The Wycliffe Exegetical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.78"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WMANT")]), _vm._v(" Wissenschaftliche Monographien zum Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.127"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("WO")]), _vm._v(" "), _c('i', [_vm._v("Die Welt des Orients")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.20"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZAW")]), _vm._v(" "), _c('i', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.48"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZDPV")]), _vm._v(" "), _c('i', [_vm._v("Zeitschrift des deutschen Palästina-Vereins")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.117"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZPEB")]), _vm._v(" M. Tenney, et al., eds., "), _c('i', [_vm._v("Zondervan Pictorial Encyclopedia of the Bible")]), _vm._v(". 5 vols. Grand Rapids: Zondervan, 1975–76")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.45"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZTK")]), _vm._v(" "), _c('i', [_vm._v("Zeitschrift für Theologie und Kirche")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21e742ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-nicot04nu-0007.vue
// module id = 72
// module chunks = 0